import { MENTION_PATTERN_WITH_CAPTURE_REGEX } from '../constants'

/**
 * Extracts unique user IDs from markdown content that contains mentions.
 * Mentions are in the format: @[username](user:userId)
 *
 * @param markdownContent - The markdown content string to extract mentions from
 * @returns An array of unique user IDs found in the content, or undefined if no mentions found
 *
 * @example
 * ```ts
 * const content = "Hello @[John Doe](user:123) and @[Jane Smith](user:456)"
 * const userIds = extractMentionedUserIds(content)
 * // Returns: ["123", "456"]
 * ```
 */
export const extractMentionedUserIds = (
  markdownContent: string
): string[] | undefined => {
  if (!markdownContent) {
    return undefined
  }

  const mentionedUserIds = new Set<string>()
  const mentionRegex = new RegExp(MENTION_PATTERN_WITH_CAPTURE_REGEX)
  let match: RegExpExecArray | null

  while ((match = mentionRegex.exec(markdownContent)) !== null) {
    const userId = match[2] // Group 2 contains the userId
    if (userId) {
      mentionedUserIds.add(userId)
    }
  }

  return mentionedUserIds.size > 0 ? Array.from(mentionedUserIds) : undefined
}
